var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteModalSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "#DD636E",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_594_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0796 6H12.5857C11.2459 6 10.1597 7.08615 10.1597 8.42605V28.3908C10.1597 29.7306 11.2458 30.8168 12.5857 30.8168H28.0796C29.4194 30.8168 30.5056 29.7307 30.5056 28.3908V8.42605C30.5056 7.0862 29.4194 6 28.0796 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9172 30.8166H12.5855C11.2462 30.8166 10.1602 29.7305 10.1602 28.3913V8.42594C10.1602 7.08609 11.2462 6 12.5855 6H13.9172C12.5773 6 11.4912 7.08609 11.4912 8.42594V28.3913C11.4912 29.7305 12.5773 30.8166 13.9172 30.8166Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.506 16.2766V28.391C30.506 29.7306 29.4198 30.8169 28.0801 30.8169H12.586C11.2463 30.8169 10.1602 29.7307 10.1602 28.391V11.0541C10.3196 11.0338 10.4818 11.0237 10.6469 11.0237H18.6514C19.9979 11.0237 21.2469 11.7273 21.9444 12.8789L22.7726 14.2457C23.4706 15.3972 24.7191 16.1009 26.0655 16.1009H29.3534C29.7551 16.1008 30.1421 16.1622 30.506 16.2766Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2036 21.4131V30.1495C33.2036 32.2761 31.4797 33.9999 29.3532 33.9999H10.6468C8.52025 33.9999 6.79639 32.2761 6.79639 30.1495V16.3363C6.79639 14.2098 8.52025 12.486 10.6468 12.486H18.6512C19.9978 12.486 21.2465 13.1894 21.9443 14.3411L22.7723 15.7077C23.4701 16.8593 24.7188 17.5628 26.0654 17.5628H29.3531C31.4796 17.5627 33.2036 19.2866 33.2036 21.4131Z",
    fill: "#E63946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6702 33.9997H10.6466C8.52036 33.9997 6.79639 32.2758 6.79639 30.1496V16.3361C6.79639 14.2093 8.52036 12.4859 10.6466 12.4859H12.6702C10.5435 12.4859 8.8195 14.2093 8.8195 16.3361V30.1496C8.8195 32.2758 10.5434 33.9997 12.6702 33.9997Z",
    fill: "#F25D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1294 24.4131L23.9489 22.5936C24.2559 22.2866 24.2559 21.7888 23.9489 21.4818L22.9313 20.4641C22.6243 20.1571 22.1265 20.1571 21.8195 20.4641L20 22.2837L18.1805 20.4641C17.8735 20.1571 17.3757 20.1571 17.0687 20.4641L16.0511 21.4818C15.744 21.7888 15.744 22.2866 16.0511 22.5936L17.8706 24.4131L16.0511 26.2326C15.744 26.5396 15.744 27.0374 16.0511 27.3444L17.0687 28.362C17.3757 28.669 17.8735 28.669 18.1805 28.362L20 26.5425L21.8195 28.362C22.1265 28.669 22.6243 28.669 22.9313 28.362L23.9489 27.3444C24.2559 27.0374 24.2559 26.5396 23.9489 26.2326L22.1294 24.4131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_594_1692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalSvg);
export default __webpack_public_path__ + "static/media/DeleteModalSvg.ed51db7efea5b6ac52396756532da44e.svg";
export { ForwardRef as ReactComponent };